import { render, staticRenderFns } from "./ModalSubmitBtns.vue?vue&type=template&id=18d0a677&scoped=true&"
import script from "./ModalSubmitBtns.vue?vue&type=script&lang=js&"
export * from "./ModalSubmitBtns.vue?vue&type=script&lang=js&"
import style0 from "./ModalSubmitBtns.vue?vue&type=style&index=0&id=18d0a677&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d0a677",
  null
  
)

export default component.exports